/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Page_EmptyInputs */

const en_shop_page_empty = /** @type {(inputs: Shop_Page_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing in the shop yet`)
};

const pl_shop_page_empty = /** @type {(inputs: Shop_Page_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W sklepie jeszcze nic nie ma`)
};

/**
* | output |
* | --- |
* | "Nothing in the shop yet" |
*
* @param {Shop_Page_EmptyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_page_empty = /** @type {((inputs?: Shop_Page_EmptyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Page_EmptyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_page_empty(inputs)
	return en_shop_page_empty(inputs)
});